import styled from 'styled-components'

export const Tabs = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
`

export const TabButton = styled.button`
    flex: 1;
    padding: 14px 18px;
    border: 1px solid #cfd9ea;
    border-radius: 14px;
    background: ${({ $active }) => ($active ? 'linear-gradient(135deg, #4a6fb0, #355486)' : '#ffffff')};
    color: ${({ $active }) => ($active ? '#ffffff' : '#39598a')};
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    border-color: ${({ $active }) => ($active ? 'transparent' : '#cfd9ea')};
    box-shadow: ${({ $active }) => ($active ? '0 6px 14px rgba(53, 84, 134, 0.28)' : 'none')};
    transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease,
        color 0.2s ease, border-color 0.2s ease;

    &:hover {
        border-color: ${({ $active }) => ($active ? 'transparent' : '#4a6fb0')};
        background: ${({ $active }) => ($active ? 'linear-gradient(135deg, #4a6fb0, #355486)' : '#f8fbff')};
    }
`
